import { $authHost, $host } from './index';

export const uploadPautinaFile = async (file) => {
    const formData = new FormData();
    formData.append('file', file);
    
    try {
        const response = await $authHost.post('/api/pautina/upload', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return response;
    } catch (error) {
        console.error('Ошибка загрузки файла:', error);
        if (error.response) {
            throw new Error(error.response.data.message || 'Ошибка загрузки файла');
        }
        throw error;
    }
};

export const getPautinaFiles = async () => {
    const response = await $authHost.get('/api/pautina/files');
    return response;
};

export const getPautinaFileData = async (fileId) => {
    const response = await $authHost.get(`/api/pautina/files/${fileId}/data`);
    return response;
};

export const deletePautinaFile = async (fileId) => {
    const response = await $authHost.delete(`/api/pautina/files/${fileId}`);
    return response;
};

export const downloadPautinaFile = async (fileId) => {
    const response = await $authHost.get(`/api/pautina/files/${fileId}/download`, {
        responseType: 'blob'
    });
    return response;
}; 